import React from 'react';
import './mediaHeader.scss';
import { Link } from 'react-router-dom';
function MediaHeader (props) {
  return (
        <div className='mediaHeader-nav'>
            <ul className='mediaHeader-list'>
                <li className={`${props.media === 'media_all' && 'active'}`}>
                    <Link to={`/press/${props.url}/media_all`}>ALL</Link>
                </li>
                <li className={`${props.media === 'photos' && 'active'}`}>
                    <Link to={`/press/${props.url}/photos`}>PHOTOS</Link>
                </li>
                {props.gallery && props.gallery.length !== 0 && (
                    <li className={`${props.media === 'videos' && 'active'}`}>
                        <Link to={`/press/${props.url}/videos`}>VIDEOS</Link>
                    </li>
                )}
            </ul>
        </div>
  );
}
export default MediaHeader;
